module.exports = __webpack_public_path__ + "static/img/noneData.d861b54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/noneData.png
// module id = Ynib
// module chunks = 8